import {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

interface SendMessageRequest {
  sender_name: string;
  sender_email: string;
  sender_phone_number: string;
  message: string;
}

interface SendMessageResponse {
  data: {
    success: boolean;
  };
}

export const useContactMessageMutation = (
  options?: UseMutationOptions<SendMessageResponse, AxiosError, SendMessageRequest>,
) =>
  useMutation<SendMessageResponse, AxiosError, SendMessageRequest>(
    (params) => api.post('v3/contact-messages', params),
    options,
  );
